import axios from "axios";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import ValidationError from "../../ZodError";
import { AccountGroup } from "./getSingleAccountGroupV4";
export const AccountGroups = AccountGroup.array();
export const url = () => {
    return environment() === "PROD"
        ? "https://middleware.prod.farther.com/account-groups/v4/account-groups"
        : "https://middleware.uat.farther.com/account-groups/v4/account-groups";
};
export default async function getAccountGroupsV4(config) {
    const { data } = await axios.get(url(), {
        headers: {
            Authorization: `Bearer ${config.jwt}`,
            ...("advisorId" in config && { Advisor: config.advisorId }),
            ...("clientId" in config && { Client: config.clientId }),
        },
    });
    const decoded = AccountGroups.safeParse(data);
    if (decoded.success) {
        return decoded.data;
    }
    else {
        const errorMessage = "getAccountGroupsV4 returned unexpected data.";
        errorLog(errorMessage, decoded.error.message);
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
}
//# sourceMappingURL=getAccountGroupsV4.js.map